import gql from "graphql-tag";

export const LIST_PURCHASE_ORDERS = gql`
  query purchaseOrders($filter: PurchaseOrdersFilter, $pagination: PaginationInput) {
    purchaseOrders(filter: $filter, pagination: $pagination) {
      entries {
        id
        status
        adviceSent
        adviceSentAt
        partnerName
        destinationWarehouseId
        poNumber
        orderDate
        expectedDeliveryDate
        totalQuantity
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const GET_PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!) {
    purchaseOrder(id: $id) {
      id
      status
      adviceSent
      adviceSentAt
      adviceSentBy
      partnerId
      partnerName
      destinationWarehouseId
      poNumber
      supplierReference
      orderDate
      expectedDeliveryDate
      transportType
      carrierReference
      notes
      totalQuantity
      cancelReason
      orderedAt
      receivedAt
      lines {
        sku
        productTitle
        quantity
        receivedQuantity
      }
    }
  }
`;

export const ON_PURCHASE_ORDER_UPDATED = gql`
  subscription onPurchaseOrderUpdated {
    purchaseOrderUpdated {
      id
    }
  }
`;
